module.exports = __webpack_public_path__ + "media/images/lb/591-5daf94b85feb3f537f31f8bcd30f55ad.svg";